module.exports = __webpack_public_path__ + "static/media/Seitenichtgefunden-xs-rgb.3e63757f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Seitenichtgefunden-xs-rgb.svg
// module id = 483
// module chunks = 0